import { Ripple } from "@/shared/ui/Ripple";

export interface IAppPopupSettings {
    message: string;
    confirmHandler?: { () };
    confirmButton?: string;
    cancelButton?: string;
    cancelHandler?: { () };
    uniqueId?: string;
    highlightConfirm?: boolean;
    highlightCancel?: boolean;
    confirmBtnOnTheLeft?: boolean;
    showCloseButton?: boolean;
}

export class Popup {
    public static showWithOptions(options: IAppPopupSettings): JQuery | null {
        return Popup.show(
            options.message,
            options.confirmHandler,
            options.confirmButton,
            options.cancelButton,
            options.uniqueId,
            options.highlightConfirm,
            options.highlightCancel,
            options.confirmBtnOnTheLeft,
            options.cancelHandler,
            options.showCloseButton
        );
    }

    public static show(
        message: string,
        confirmHandler?: { () },
        confirmButton?: string,
        cancelButton?: string,
        uniqueId?: string,
        highlightConfirm?: boolean,
        highlightCancel?: boolean,
        confirmBtnOnTheLeft?: boolean,
        cancelHandler?: { () },
        showCloseButton?: boolean
    ): JQuery | null {
        const parent = $(".app");

        if (uniqueId !== undefined) {
            if (parent.find(".popup." + uniqueId).length !== 0) return null;
        }

        //dim background
        let dim = parent.find("> .dim.popupdim");
        if (dim.length === 0) dim = $('<div class="dim popupdim" />').appendTo(parent);
        else dim.stop(true, false);

        dim[0].offsetHeight;
        dim.addClass("shown");

        const msg = $(
            '<div class="popup' +
                (uniqueId === undefined ? "" : " " + uniqueId) +
                '"><div class="text">' +
                message +
                "</div></div>"
        ).appendTo(parent);

        if (showCloseButton) {
            //add close indicator
            $('<div class="closer"><i class="fal fa-times"></i></div>')
                .prependTo(msg)
                .click((e) => {
                    e.preventDefault();
                    Popup.close($(e.currentTarget).parent());
                });
        }

        const btns = $('<div class="btns" />').appendTo(msg);

        if (confirmBtnOnTheLeft === true) {
            if (cancelButton !== undefined) {
                this.addCancelButton(btns, highlightConfirm, cancelButton, highlightCancel, cancelHandler);
                btns.addClass("split");
            }
            this.addConfirmButton(btns, confirmHandler, confirmButton, highlightConfirm);
        } else {
            this.addConfirmButton(btns, confirmHandler, confirmButton, highlightConfirm);
            if (cancelButton !== undefined) {
                btns.addClass("split");
                this.addCancelButton(btns, highlightConfirm, cancelButton, highlightCancel, cancelHandler);
            }
        }

        msg[0].offsetHeight;
        msg.css("margin-top", (msg.height() + 60) / -2);
        msg.addClass("shown");

        return msg;
    }

    private static addCancelButton(
        buttonsContainer: JQuery,
        highlightConfirm?: boolean,
        cancelButton?: string,
        highlightCancel?: boolean,
        cancelHandler?: { () }
    ) {
        Ripple.bind(
            $(
                '<button class="btn ' +
                    (highlightCancel === true ? "orange" : highlightConfirm === true ? "" : "secondary") +
                    '">' +
                    cancelButton +
                    "</button>"
            )
                .appendTo(buttonsContainer)
                .click((e) => {
                    e.preventDefault();
                    if (cancelHandler != null) {
                        cancelHandler();
                    }

                    Popup.close($(e.currentTarget).parent().parent());
                })
        );
    }

    private static addConfirmButton(
        buttonsContainer: JQuery,
        confirmHandler?: { () },
        confirmButton?: string,
        highlightConfirm?: boolean
    ) {
        Ripple.bind(
            $(
                '<button class="btn confirm ' +
                    (highlightConfirm !== undefined && highlightConfirm === true ? "orange" : "") +
                    '">' +
                    (confirmButton === undefined ? "Ok" : confirmButton) +
                    "</button>"
            )
                .appendTo(buttonsContainer)
                .click((e) => {
                    e.preventDefault();
                    Popup.close($(e.currentTarget).parent().parent());

                    if (confirmHandler !== undefined) confirmHandler();
                })
        );
    }

    private static close($popup: JQuery) {
        $popup.addClass("closing")[0].offsetHeight;
        const totalPopups = $(".app > .popup").length;

        $popup
            .removeClass("shown")
            .delay(600)
            .queue((e) => {
                $popup.remove();
                e();
            });

        //check if dim needs to be removed
        if (totalPopups <= 1) {
            const dim = $(".app > .dim.popupdim")
                .delay(250)
                .queue((c) => {
                    dim.removeClass("shown")
                        .delay(350)
                        .queue((a) => {
                            dim.remove();
                            a();
                        });

                    c();
                });
        }
    }
}
